import {
  IonAlert,
  IonCheckbox,
  IonChip,
  IonContent,
  IonFab,
  IonFabButton,
  IonFabList,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
  useIonViewWillLeave,
} from "@ionic/react";
import { endOfDay, startOfDay } from "date-fns";
import {
  arrowBack,
  close,
  closeCircleOutline,
  ellipsisHorizontal,
  pauseOutline,
} from "ionicons/icons";
import PubSub from "pubsub-js";
import { useContext, useEffect, useState, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { OrderStatus, OrderBookFilterType } from "./Constants";
import optionsGridConfig from "../OptionsGrid/optionsGridConfig";
import {
  MetricConstants,
  MetricTypeConstants,
} from "../../../components/Constants";
import { UserPreferencesContext } from "../../../components/contexts/UserPreferencesContext";
import { OrderbookFiltersContext } from "../../../components/contexts/OrderbookFiltersContext";
import config from "../../../components/helpers/socket/config";
import { pubsubEvents } from "../../../components/helpers/socket/pubsubEvent";
import { orderBook } from "../../../driverTitleAndDesc";
import { globalDriverJsFunction } from "../../../globalDriverConfig";
import expandIcon from "../../../theme/custom-icons/expand_more.svg";
import searchIcon from "../../../theme/custom-icons/search.svg";
import firebaseEventConfig from "../../../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../../../utils/firebaseAnalytics/firebaseUtils";
import { startMetric } from "../../../utils/metric-utils/metricUtils";
import { send } from "../../../utils/sockets/asyncSocket";
import { CMEDPermissions } from "../MarketData/MarketDataContent";
import OrderBookListComponent from "./OrderBookListComponent";
import Skeleton__OrderBook from "./Skeleton__OrderBook";
import useOutsideAlerter from "../common/utils/useOutsideAlerter";
import { OrdersDataType, OrdersType } from "../../../Constants";
import AppPrefContext from "../../../components/contexts/AppPrefContext";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 */

type OrderBookProps = {
  isUserSettingsModalOpen: any;
  userCMEDEntitlements: CMEDPermissions | undefined;
};

const OrderBookContent: React.FC<OrderBookProps> = ({
  userCMEDEntitlements,
}) => {
  const bulkActionInProgress = useRef(false);
  const searchRef = useRef<HTMLIonInputElement>(null);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const accountPickerRef = useRef<HTMLDivElement>(null);
  const visibilityPickerRef = useRef<HTMLDivElement>(null);
  const overlayRef = useRef<HTMLDivElement>(null);
  const [orderBookData, setOrderBookData] = useState<any[]>([]);
  const [staticOrderBookData, setStaticOrderBookData] = useState<any[]>([]);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [searchVal, setSearchVal] = useState<any>("");
  const [accounts, setAccounts] = useState<any[]>([]);
  const [updatedUserPrefData, setUpdatedUserPrefData] = useState(false);
  const [activeFilters, setActiveFilters] = useState<any>([
    { Accounts: [], "Order Status": [], Time: ["Today"] },
  ]);
  const [currentSelectedTime, setCurrentSelectedTime] =
    useState<string>("Today");
  const [isHoldAllOrdersAlertOpen, setIsHoldAllOrdersAlertOpen] =
    useState<boolean>(false);
  const [isKillAllOrdersAlertOpen, setIsKillAllOrdersAlertOpen] =
    useState<boolean>(false);
  const { userPreferences, setUserPreferences } = useContext(
    UserPreferencesContext,
  );
  const appPref = useContext(AppPrefContext);
  const { visibility, setVisibility } = useContext(OrderbookFiltersContext);
  const [isDateDropDownOpen, setIsDateDropDownOpen] = useState(false);
  const [isAccountDropDownOpen, setIsAccountDropDownOpen] = useState(false);
  const [isVisibilityDropDownOpen, setIsVisibilityDropDownOpen] =
    useState(false);
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [selectedFilterPill, setSelectedFilterPill] = useState<string>("All");
  const [fabButtonOptions, setFabButtonOptions] = useState<boolean>(false);

  const closeDropdowns = () => {
    setIsDateDropDownOpen(false);
    setIsAccountDropDownOpen(false);
    setIsVisibilityDropDownOpen(false);
  };

  const isAnyDropdownOpen =
    isDateDropDownOpen || isAccountDropDownOpen || isVisibilityDropDownOpen;

  useOutsideAlerter(
    [datePickerRef, accountPickerRef, visibilityPickerRef],
    closeDropdowns,
    isAnyDropdownOpen,
  );

  // const driverActiveFunction = () => {
  //   if (userPreferences.app_tour !== "") {
  //     if (
  //       window.location.pathname === "/cmed/order-book" &&
  //       typeof userPreferences.app_tour == "string" &&
  //       JSON.parse(userPreferences.app_tour).order == false
  //     ) {
  //       const driverData = {
  //         type: "order",
  //         steps: orderBook,
  //         userPreferences: userPreferences,
  //         setUserPreferences: setUserPreferences,
  //         setUpdatedUserPrefData: setUpdatedUserPrefData,
  //         updatedUserPrefData: updatedUserPrefData,
  //       };
  //       setTimeout(() => {
  //         globalDriverJsFunction(driverData);
  //       }, 300);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   setUserPreferences(userPreferences);
  // }, [updatedUserPrefData]);

  // useEffect(() => {
  //   driverActiveFunction();
  // }, [JSON.stringify(userPreferences.app_tour), isUserSettingsModalOpen]);

  const filterOptions = [
    {
      optionTitle: "Order Status",
      type: "check",
      options: ["Working", "Filled", "Held", "Cancelled", "Pending"],
    },
    {
      optionTitle: "Time",
      type: "radio",
      options: [
        "Today",
        "Last 2 days",
        "Last 3 days",
        "Last 4 days",
        "Last 5 days",
      ],
    },
    {
      optionTitle: "Accounts",
      type: "check",
      options: accounts,
    },
  ];

  const statusGetter = (orderStatus: number | undefined) => {
    switch (orderStatus) {
      case 0:
        return OrderStatus.HELD;
      case 1:
        return OrderStatus.WORKING;
      case 2:
        return OrderStatus.PARTIAL_FILLED;
      case 3:
        return OrderStatus.PARTIAL_FILLED_HELD;
      case 4:
        return OrderStatus.PARTIAL_FILLED_CANCELLED;
      case 5:
        return OrderStatus.FILLED;
      case 6:
        return OrderStatus.CANCELLED;
      case 7:
        return OrderStatus.PENDING;
      case 8:
        return OrderStatus.PENDING_HELD;
      default:
        return OrderStatus.HELD;
    }
  };

  const dayGetter = (timestamp: any, type: any) => {
    const isBusinessDay = (date: Date) => {
      const day = date.getDay();
      return day !== 0 && day !== 6; //O = Sunday, 6 = Saturday
    };

    const SubBusinessDays = (date: Date, days: number) => {
      let count = 0;
      while (count < days) {
        date.setDate(date.getDate() - 1);
        if (isBusinessDay(date)) {
          count++;
        }
      }
      return date;
    };

    switch (type) {
      case "Today":
        return (
          timestamp >= startOfDay(new Date()).getTime() &&
          timestamp <= endOfDay(new Date()).getTime()
        );
      case "Last 2 days":
        return (
          timestamp >= SubBusinessDays(startOfDay(new Date()), 1) &&
          timestamp <= endOfDay(new Date()).getTime()
        );

      case "Last 3 days":
        return (
          timestamp >= SubBusinessDays(startOfDay(new Date()), 2) &&
          timestamp <= endOfDay(new Date()).getTime()
        );

      case "Last 4 days":
        return (
          timestamp >= SubBusinessDays(startOfDay(new Date()), 3) &&
          timestamp <= endOfDay(new Date()).getTime()
        );

      case "Last 5 days":
        return (
          timestamp >= SubBusinessDays(startOfDay(new Date()), 4) &&
          timestamp <= endOfDay(new Date()).getTime()
        );
    }
  };

  // Filter By accounts and order status
  const __filterbyOrderStatusAccount = (filterData: any) => {
    let filterByCateogry: any[] = [];
    if (
      activeFilters[0]["Order Status"].length > 0 &&
      activeFilters[0]["Accounts"].length > 0
    ) {
      filterByCateogry = filterData.filter(
        (obj: any) =>
          activeFilters[0]["Accounts"].includes(obj.a) &&
          activeFilters[0]["Order Status"].includes(statusGetter(obj?.s)),
      );
    } else if (activeFilters[0]["Order Status"].length > 0) {
      filterByCateogry = filterData.filter((obj: any) =>
        activeFilters[0]["Order Status"].includes(statusGetter(obj?.s)),
      );
    } else if (activeFilters[0]["Accounts"].length > 0) {
      filterByCateogry = filterData.filter((obj: any) =>
        activeFilters[0]["Accounts"].includes(obj.a),
      );
    } else {
      return filterData;
    }
    return filterByCateogry;
  };

  // Filter By Accounts only
  const __filterbyAccount = (filterData: any) => {
    let filterByAccount: any[] = [];
    if (activeFilters[0]["Accounts"].length > 0) {
      filterByAccount = filterData.filter((obj: any) =>
        activeFilters[0]["Accounts"].includes(obj.a),
      );
    } else {
      return filterData;
    }
    return filterByAccount;
  };

  const _filterWorkingPartiallyfilledPendingOrders = (data: any) => {
    let working_partiallyfilled_pending_orders = data.filter((obj: any) =>
      [1, 2, 7].includes(obj.s),
    );
    return __filterbyAccount(working_partiallyfilled_pending_orders);
  };

  const _filterPartiallyfilledOrders = (data: any) => {
    let partiallyfilled_orders = data.filter((obj: any) => [2].includes(obj.s));
    return __filterbyAccount(partiallyfilled_orders);
  };

  //Real time filtering
  const handleOrderBookFilterSearch = () => {
    let main_data = staticOrderBookData;
    switch (selectedFilterPill) {
      case OrderBookFilterType.ALL:
        /**
         * @description
         * "All" will filter Working, Partially Filled and Pending orders by account only.
         * Rest everything will filter by time and account.
         * Order status is empty[] for this case.
         */

        let except_working_partiallyfilled_pending_orders = main_data.filter(
          (obj: any) => ![1, 2, 7].includes(obj.s),
        );

        const filtered_by_time_and_account_except_working_partiallyfilled_pending_orders =
          __filterbyAccount(
            except_working_partiallyfilled_pending_orders,
          ).filter((obj: any) => {
            const timeFilterType = activeFilters[0]["Time"][0];
            // 1. Check if the Order Time (obj.o) matches the date range
            const isOrderInDateRange = dayGetter(
              new Date(obj?.o).getTime(),
              timeFilterType,
            );
            // 2. Check if the Last Applied Transaction Time (obj.l) matches the date range
            const isLastTransactionInDateRange = obj.l
              ? dayGetter(new Date(obj?.l).getTime(), timeFilterType)
              : false;
            // 3. Return true if EITHER timestamp falls within the selected range
            return isOrderInDateRange || isLastTransactionInDateRange;
          });

        const filtered_by_account_working_partiallyfilled_pending_orders =
          _filterWorkingPartiallyfilledPendingOrders(main_data);
        setOrderBookData(
          [
            ...filtered_by_account_working_partiallyfilled_pending_orders,
            ...filtered_by_time_and_account_except_working_partiallyfilled_pending_orders,
          ].sort(
            (a: any, b: any) =>
              new Date(b.o).getTime() - new Date(a.o).getTime(),
          ),
        );

        break;
      case OrderBookFilterType.WORKING:
        /**
         * @description
         * "Working" will filter on the order status: Working, Partially Filled by account only.
         * In this case it will not filter by time.
         */
        setOrderBookData(
          __filterbyOrderStatusAccount(main_data).sort(
            (a: any, b: any) =>
              new Date(b.o).getTime() - new Date(a.o).getTime(),
          ),
        );
        break;
      case OrderBookFilterType.WITH_FILLS:
        /**
         * @description
         * "With Fills" will filter Partially Filled orders by account only.
         * Filled, Partially Filled & Held, Partially Filled & Cancelled orders will be filtered by time and account.
         * Order status is empty[] for this case.
         */
        let f_pfh_pfc_orders = main_data.filter((obj: any) =>
          [3, 4, 5].includes(obj.s),
        );

        const filtered_by_time_and_account_f_pfh_pfc_orders = __filterbyAccount(
          f_pfh_pfc_orders,
        ).filter((obj: any) => {
          const timeFilterType = activeFilters[0]["Time"][0];
          // 1. Check if the Order Time (obj.o) matches the date range
          const isOrderInDateRange = dayGetter(
            new Date(obj?.o).getTime(),
            timeFilterType,
          );
          // 2. Check if the Last Applied Transaction Time (obj.l) matches the date range
          const isLastTransactionInDateRange = obj.l
            ? dayGetter(new Date(obj?.l).getTime(), timeFilterType)
            : false;
          // 3. Return true if EITHER timestamp falls within the selected range
          return isOrderInDateRange || isLastTransactionInDateRange;
        });

        let filtered_by_account_partiallyfilled_orders =
          _filterPartiallyfilledOrders(main_data);
        setOrderBookData(
          [
            ...filtered_by_account_partiallyfilled_orders,
            ...filtered_by_time_and_account_f_pfh_pfc_orders,
          ].sort(
            (a: any, b: any) =>
              new Date(b.o).getTime() - new Date(a.o).getTime(),
          ),
        );
        break;
      case OrderBookFilterType.CANCELLED:
        /**
         * @description
         * "Cancelled" will filter on the order status: Cancelled, Partially Filled & Cancelled by account and time.
         */
        // setOrderBookData(
        //   __filterbyOrderStatusAccount(main_data).filter((obj: any) =>
        //     dayGetter(new Date(obj.o).getTime(), activeFilters[0]["Time"][0])
        //   )
        // );
        setOrderBookData(
          __filterbyOrderStatusAccount(main_data)
            .filter((obj: any) => {
              const timeFilterType = activeFilters[0]["Time"][0];
              // 1. Check if the Order Time (obj.o) matches the date range
              const isOrderInDateRange = dayGetter(
                new Date(obj?.o).getTime(),
                timeFilterType,
              );
              // 2. Check if the Last Applied Transaction Time (obj.l) matches the date range
              const isLastTransactionInDateRange = obj.l
                ? dayGetter(new Date(obj?.l).getTime(), timeFilterType)
                : false;
              // 3. Return true if EITHER timestamp falls within the selected range
              return isOrderInDateRange || isLastTransactionInDateRange;
            })
            .sort(
              (a: any, b: any) =>
                new Date(b.o).getTime() - new Date(a.o).getTime(),
            ),
        );
        break;
      case OrderBookFilterType.HELD:
        /**
         * @description
         * "Held" will filter on the order status: Held, Partially Filled & Held, Pending & Held by account and time.
         */
        // setOrderBookData(
        //   __filterbyOrderStatusAccount(main_data).filter((obj: any) =>
        //     dayGetter(new Date(obj.o).getTime(), activeFilters[0]["Time"][0])
        //   )
        // );
        setOrderBookData(
          __filterbyOrderStatusAccount(main_data)
            .filter((obj: any) => {
              const timeFilterType = activeFilters[0]["Time"][0];
              // 1. Check if the Order Time (obj.o) matches the date range
              const isOrderInDateRange = dayGetter(
                new Date(obj?.o).getTime(),
                timeFilterType,
              );
              // 2. Check if the Last Applied Transaction Time (obj.l) matches the date range
              const isLastTransactionInDateRange = obj.l
                ? dayGetter(new Date(obj?.l).getTime(), timeFilterType)
                : false;
              // 3. Return true if EITHER timestamp falls within the selected range
              return isOrderInDateRange || isLastTransactionInDateRange;
            })
            .sort(
              (a: any, b: any) =>
                new Date(b.o).getTime() - new Date(a.o).getTime(),
            ),
        );
        break;
      default:
        break;
    }
  };

  const getResForTradingOrders = (msg: any, response: any) => {
    const { data, isSnapshot } = response.payload;
    switch (isSnapshot) {
      case true:
        //for initial page load
        setOrderBookData(data);
        setStaticOrderBookData(data);
        setAccounts(
          data
            .map((item: { a: any }) => item.a)
            .filter(
              (value: any, index: any, self: string | any[]) =>
                self.indexOf(value) === index,
            ),
        );
        setOrdersLoading(false);
        break;
      case null:
        setAccounts((prevAccounts) => {
          const newAccounts = data.map((item: { a: any }) => item.a);
          const combinedAccounts = [...prevAccounts, ...newAccounts];
          return combinedAccounts.filter(
            (value: any, index: any, self: string | any[]) =>
              self.indexOf(value) === index,
          );
        });
        setOrderBookData((prevOrderBookData) => {
          let updatedData = [...prevOrderBookData];
          const newItems: any[] = [];
          data.forEach((incomingOrder: any) => {
            const existingIndex = updatedData.findIndex(
              (order) => order.id === incomingOrder.id,
            );
            if (existingIndex !== -1) {
              updatedData[existingIndex] = {
                ...updatedData[existingIndex],
                ...incomingOrder,
              };
            } else {
              const newOrder = {
                ...incomingOrder,
                marketData: incomingOrder.marketData || {},
              };
              newItems.push(newOrder);
            }
          });
          return [...newItems, ...updatedData];
        });
        setStaticOrderBookData((prevOrderBookData) => {
          let updatedData = [...prevOrderBookData];
          const newItems: any[] = [];
          data.forEach((incomingOrder: any) => {
            const existingIndex = updatedData.findIndex(
              (order) => order.id === incomingOrder.id,
            );
            if (existingIndex !== -1) {
              updatedData[existingIndex] = {
                ...updatedData[existingIndex],
                ...incomingOrder,
              }; // merge existing
            } else {
              const newOrder = {
                ...incomingOrder,
                marketData: incomingOrder.marketData || {},
              };
              newItems.push(newOrder);
            }
          });
          return [...newItems, ...updatedData];
        });
        setOrdersLoading(false);
        //  check for market data after order update.
        if (data[0] && data[0].ii && !bulkActionInProgress.current) {
          send(config.socket.channels.TRADING, subRequestForTradingOrders);
        }
        break;
      default:
        break;
    }
  };

  const getResForTradingOrderMarketData = (msg: any, response: any) => {
    const { data, isSnapshot } = response.payload;
    switch (isSnapshot) {
      case true:
        //for initial page load
        setOrderBookData((orderBookData) => {
          let matchedArr: any[] = [];
          let OBwithMarketData: any[] = [];
          orderBookData.forEach((item: any) => {
            if (data[0].id === item.ii) {
              var assignObjs = Object.assign(item, { marketData: data[0] });
              matchedArr.push(assignObjs);
            }
          });
          var res = orderBookData.map(
            (obj: any) => matchedArr.find((o) => o.id === obj.id) || obj,
          );
          OBwithMarketData = res;
          return OBwithMarketData;
        });
        setStaticOrderBookData((orderBookData) => {
          let matchedArr: any[] = [];
          let OBwithMarketData: any[] = [];
          orderBookData.forEach((item: any) => {
            if (data[0].id === item.ii) {
              var assignObjs = Object.assign(item, { marketData: data[0] });
              matchedArr.push(assignObjs);
            }
          });
          var res = orderBookData.map(
            (obj: any) => matchedArr.find((o) => o.id === obj.id) || obj,
          );
          OBwithMarketData = res;
          return OBwithMarketData;
        });
        setOrdersLoading(false);
        break;
      case null:
        setOrderBookData((orderBookData) => {
          let matchedArr: any[] = [];
          let OBwithMarketData: any[] = [];
          orderBookData.forEach((item: any) => {
            if (data[0] && data[0].id === item.ii) {
              var assignObjs = Object.assign(item, { marketData: data[0] });
              matchedArr.push(assignObjs);
            }
          });
          var res = orderBookData.map(
            (obj: any) => matchedArr.find((o) => o.id === obj.id) || obj,
          );
          OBwithMarketData = res;
          return OBwithMarketData;
        });
        setStaticOrderBookData((orderBookData) => {
          let matchedArr: any[] = [];
          let OBwithMarketData: any[] = [];
          orderBookData.forEach((item: any) => {
            if (data[0] && data[0].id === item.ii) {
              var assignObjs = Object.assign(item, { marketData: data[0] });
              matchedArr.push(assignObjs);
            }
          });
          var res = orderBookData.map(
            (obj: any) => matchedArr.find((o) => o.id === obj.id) || obj,
          );
          OBwithMarketData = res;
          return OBwithMarketData;
        });
        setOrdersLoading(false);
        break;
      default:
        break;
    }
  };

  const handleSocketError = (msg: any, response: any) => {
    const { status } = response;
    if (status === "ERROR") {
      setOrdersLoading(false);
    }
  };

  const RenderMobileHeader = () => {
    return (
      <div>
        <IonItem
          className="ion-no-padding"
          lines="none"
          style={{
            "--inner-padding-end": 0,
            "--min-height": "0px",
            "--background": "none",
          }}
        >
          <div className="ob__header_parent">
            <div className="ob__contract_side_status_header">
              CONTRACT
              <br />
              SIDE / STATUS
            </div>
            <div className="ob__price_fills_header">
              PRICE
              <br />
              FILLS
            </div>
            <div className="ob__bid_bidqty_header">
              BID
              <br />
              QTY
            </div>
            <div className="ob__offer_offerqty_header">
              OFFER
              <br />
              QTY
            </div>
          </div>
        </IonItem>
      </div>
    );
  };

  let subRequestForTradingOrders = {
    action: optionsGridConfig.socket.actions.CMED_ORDERS_SUBSCRIBE,
    type: OrdersType.ORDERS_DATA_SUBSCRIBE,
    requestID: uuidv4(),
    payload: {
      ordersDataType: OrdersDataType.TRADING_ORDERS,
      Visibility: visibility,
    },
  };

  useEffect(() => {
    const orderUpdatesToken = PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_ORDER_UPDATES,
      getResForTradingOrders,
    );
    const marketDataToken = PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_ORDER_MARKET_DATA_UPDATE,
      getResForTradingOrderMarketData,
    );
    const socketErrorToken = PubSub.subscribe(
      pubsubEvents.socketKeys.HANDLE_SOCKET_ERROR,
      handleSocketError,
    );
    const bulkActionToken = PubSub.subscribe(
      pubsubEvents.eventKeys.BULK_ACTION_COMPLETE,
      () => {
        bulkActionInProgress.current = false;
      },
    );
    return () => {
      PubSub.unsubscribe(orderUpdatesToken);
      PubSub.unsubscribe(marketDataToken);
      PubSub.unsubscribe(socketErrorToken);
      PubSub.unsubscribe(bulkActionToken);
    };
  }, [visibility]);

  // useEffect(() => {
  //   if (!appPref?.isAppActive) {
  //     setOrdersLoading(true);
  //     setOrderBookData([]);
  //     setStaticOrderBookData([]);
  //     setAccounts([]);
  //   }
  // }, [appPref?.isAppActive]);

  useIonViewWillLeave(() => {
    setFabButtonOptions(false);
  });

  useEffect(() => {
    return () => {
      setIsSearchBarOpen(false);
    };
  }, [window.location.pathname]);

  useEffect(() => {
    let timeoutId: any;

    if (isSearchBarOpen) {
      timeoutId = setTimeout(() => {
        searchRef.current?.setFocus();
      }, 750);
    }
    return () => {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
    };
  }, [isSearchBarOpen]);

  useEffect(() => {
    setOrdersLoading(true);
    setOrderBookData([]);
    setStaticOrderBookData([]);
    setActiveFilters((prevFilters: any) => [
      {
        ...prevFilters[0],
        Accounts: [],
      },
    ]);
    send(config.socket.channels.TRADING, subRequestForTradingOrders);

    return () => {
      let unSubRequestForTradingOrders = {
        action: optionsGridConfig.socket.actions.CMED_ORDERS_UNSUBSCRIBE,
        type: OrdersType.ORDERS_DATA_UNSUBSCRIBE,
        requestID: uuidv4(),
        payload: {
          ordersDataType: OrdersDataType.TRADING_ORDERS,
          Visibility: visibility,
        },
      };
      send(config.socket.channels.TRADING, unSubRequestForTradingOrders);
    };
  }, [visibility]);

  useEffect(() => {
    handleOrderBookFilterSearch();
  }, [
    JSON.stringify(activeFilters),
    staticOrderBookData,
    ordersLoading,
    selectedFilterPill,
  ]);

  let requestForHoldAllOrders = {
    action: config.socket.actions.CMED_ORDER_HOLDALL,
    type: "holdAllOrdersRequest",
    requestID: uuidv4(),
    payload: {},
  };
  const holdAllOrdersHandler = () => {
    startMetric(
      MetricConstants.ORDER_HOLD_ALL_LATENCY,
      MetricTypeConstants.TIMER,
    );
    bulkActionInProgress.current = true;
    send(config.socket.channels.TRADING, requestForHoldAllOrders);
    CMEDfirebaseLogEvent(
      firebaseEventConfig.CMEDComponentNames.CMED_ORDER_BOOK,
      firebaseEventConfig.eventNames.CMED_ORDER_BOOK
        .CMED_ORDER_BOOK_HOLD_ALL_ORDERS,
    );
  };

  let requestForKillAllOrders = {
    action: config.socket.actions.CMED_ORDER_CANCELALL,
    type: "cancelAllOrdersRequest",
    requestID: uuidv4(),
    payload: {},
  };
  const killAllOrdersHandler = () => {
    startMetric(
      MetricConstants.ORDER_KILL_ALL_LATENCY,
      MetricTypeConstants.TIMER,
    );
    bulkActionInProgress.current = true;
    send(config.socket.channels.TRADING, requestForKillAllOrders);
    CMEDfirebaseLogEvent(
      firebaseEventConfig.CMEDComponentNames.CMED_ORDER_BOOK,
      firebaseEventConfig.eventNames.CMED_ORDER_BOOK
        .CMED_ORDER_BOOK_KILL_ALL_ORDERS,
    );
  };

  const handleCheck = (e: any, title: any) => {
    const { checked, value } = e.detail;
    var index = activeFilters[0][title].indexOf(value);
    if (!checked) {
      if (index !== -1) {
        const temp = [...activeFilters];
        temp[0][title].splice(index, 1);
        setActiveFilters(temp);
      }
    } else {
      const temp = [...activeFilters];
      temp[0][title].push(value);
      setActiveFilters(temp);
    }
  };

  const RadioGrpValSetter = () => {
    var temp: any[] = [];
    filterOptions.map((e: any) => {
      if (e.type === "radio") {
        temp = e.options;
      }
    });
    const filteredArray = activeFilters[0]["Time"].filter((value: any) =>
      temp.includes(value),
    );
    return filteredArray.toString();
  };

  const handleRadio = (e: any, title: any) => {
    const { value } = e.detail;
    if (value === undefined) {
      const index = activeFilters[0][title].indexOf(value);
      const temp = [...activeFilters];
      temp[0][title].splice(index, 1);
      setActiveFilters(temp);
    } else {
      if (RadioGrpValSetter().length > 0) {
        const index = activeFilters[0][title].indexOf(RadioGrpValSetter());
        const temp = [...activeFilters];
        temp[0][title].splice(index, 1);
        setActiveFilters(temp);
      }
      const temp = [...activeFilters];
      temp[0][title].push(value);
      setActiveFilters(temp);
    }
  };

  const RenderClickOverlay = () => {
    if (isAnyDropdownOpen) {
      return (
        <div
          ref={overlayRef}
          onClick={closeDropdowns}
          className="ob__dropdown_overlay"
        ></div>
      );
    }
    return null;
  };

  return (
    <>
      <IonPage>
        {ordersLoading ? (
          <>
            <IonHeader className="ion-no-border">
              <IonToolbar>
                <IonTitle></IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent>
              <Skeleton__OrderBook />
            </IonContent>
          </>
        ) : (
          <>
            <IonHeader className="ion-no-border">
              <IonToolbar>
                <IonTitle></IonTitle>
              </IonToolbar>
            </IonHeader>
            <RenderClickOverlay />
            <div className="ob__filters_wrapper">
              <div
                className={`ob__search_order`}
                id="orderSearch"
                onClick={() => {
                  closeDropdowns();
                  setIsSearchBarOpen(true);
                }}
                style={{
                  flex: isSearchBarOpen ? "1 1 85%" : "0 0 15%",
                  width: isSearchBarOpen ? "85%" : "15%",
                }}
              >
                {!isSearchBarOpen && (
                  <>
                    {searchVal?.length > 0 ? (
                      <div
                        style={{
                          height: "21px",
                          width: "21px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          background: "#112B4A",
                          border: "1px solid rgba(255, 255, 255, 0.15)",
                          borderRadius: "50%",
                          fontSize: "var(--one-font-size-10)",
                        }}
                      >
                        1
                      </div>
                    ) : (
                      <IonIcon
                        icon={searchIcon}
                        style={{
                          height: "20px",
                          width: "20px",
                          minWidth: "20px",
                        }}
                      />
                    )}
                  </>
                )}
                {isSearchBarOpen && (
                  <IonInput
                    clearInput={true}
                    clearInputIcon={close}
                    labelPlacement="fixed"
                    placeholder="Search Order..."
                    mode="ios"
                    value={searchVal}
                    onIonInput={(event: any) => {
                      setSearchVal(event.detail.value);
                      CMEDfirebaseLogEvent(
                        firebaseEventConfig.CMEDComponentNames.CMED_ORDER_BOOK,
                        firebaseEventConfig.eventNames.CMED_ORDER_BOOK
                          .CMED_ORDER_BOOK_SEARCH_ORDER,
                      );
                    }}
                    ref={searchRef}
                  ></IonInput>
                )}
              </div>
              {isSearchBarOpen && (
                <div
                  className="ob__search_order_back_btn"
                  onClick={() => setIsSearchBarOpen(false)}
                  style={{ flex: "0 0 15%", width: "15%" }}
                >
                  <IonIcon
                    icon={arrowBack}
                    style={{ height: "20px", width: "20px" }}
                  />
                </div>
              )}
              {!isSearchBarOpen && (
                <>
                  <div
                    className="ob__visibility_picker_wrapper"
                    style={{ flex: "0 0 25%", width: "25%", minWidth: "0" }}
                    ref={visibilityPickerRef}
                  >
                    <div
                      className="ob__visibility_picker"
                      onClick={() => {
                        setIsVisibilityDropDownOpen(!isVisibilityDropDownOpen);
                        setIsDateDropDownOpen(false);
                        setIsAccountDropDownOpen(false);
                        document
                          .querySelector("ion-item-sliding")
                          ?.closeOpened();
                      }}
                    >
                      <p className="ion-no-margin">
                        {visibility === "0"
                          ? "My Orders"
                          : visibility === "1"
                            ? "Desk Orders"
                            : "Company Orders"}
                      </p>
                      <IonIcon
                        icon={expandIcon}
                        style={{
                          height: "20px",
                          width: "20px",
                          minWidth: "20px",
                          transform: isVisibilityDropDownOpen
                            ? "rotate(180deg)"
                            : "rotate(0)",
                        }}
                      />
                    </div>
                    {isVisibilityDropDownOpen && (
                      <div className="ob__visibility_picker_dropdown animate__animated animate__fadeIn animate__faster">
                        <IonRadioGroup
                          value={visibility}
                          onIonChange={(e: any) => {
                            setVisibility(e.detail.value);
                            setIsVisibilityDropDownOpen(false);
                            CMEDfirebaseLogEvent(
                              firebaseEventConfig.CMEDComponentNames
                                .CMED_ORDER_BOOK,
                              firebaseEventConfig.eventNames.CMED_ORDER_BOOK
                                .CMED_ORDER_BOOK_APPLY_FILTER,
                            );
                          }}
                        >
                          <IonRadio value="0" mode="md" labelPlacement="end">
                            My Orders
                          </IonRadio>
                          <br />
                          <IonRadio value="1" mode="md" labelPlacement="end">
                            Desk Orders
                          </IonRadio>
                          <br />
                          <IonRadio value="2" mode="md" labelPlacement="end">
                            Company Orders
                          </IonRadio>
                          <br />
                        </IonRadioGroup>
                      </div>
                    )}
                  </div>
                  <div
                    className="ob__date_picker_wrapper"
                    style={{ flex: "0 0 25%", width: "25%", minWidth: "0" }}
                    ref={datePickerRef}
                  >
                    <div
                      className="ob__date_picker"
                      onClick={() => {
                        setIsDateDropDownOpen(!isDateDropDownOpen);
                        setIsAccountDropDownOpen(false);
                        setIsVisibilityDropDownOpen(false);
                        document
                          .querySelector("ion-item-sliding")
                          ?.closeOpened();
                      }}
                    >
                      <p className="ion-no-margin">{currentSelectedTime}</p>
                      <IonIcon
                        icon={expandIcon}
                        style={{
                          height: "20px",
                          width: "20px",
                          minWidth: "20px",
                          transform: isDateDropDownOpen
                            ? "rotate(180deg)"
                            : "rotate(0)",
                        }}
                      />
                    </div>
                    {isDateDropDownOpen && (
                      <div className="ob__date_picker_dropdown animate__animated animate__fadeIn animate__faster">
                        <IonRadioGroup
                          value={currentSelectedTime}
                          onIonChange={(e: any) => {
                            handleRadio(e, "Time");
                            setCurrentSelectedTime(e.detail.value);
                            setIsDateDropDownOpen(false);
                            CMEDfirebaseLogEvent(
                              firebaseEventConfig.CMEDComponentNames
                                .CMED_ORDER_BOOK,
                              firebaseEventConfig.eventNames.CMED_ORDER_BOOK
                                .CMED_ORDER_BOOK_APPLY_FILTER,
                            );
                          }}
                        >
                          <IonRadio
                            value="Today"
                            mode="md"
                            labelPlacement="end"
                          >
                            Today
                          </IonRadio>
                          <br />
                          <IonRadio
                            value="Last 2 days"
                            mode="md"
                            labelPlacement="end"
                          >
                            Last 2 days
                          </IonRadio>
                          <br />
                          <IonRadio
                            value="Last 3 days"
                            mode="md"
                            labelPlacement="end"
                          >
                            Last 3 days
                          </IonRadio>
                          <br />
                          <IonRadio
                            value="Last 4 days"
                            mode="md"
                            labelPlacement="end"
                          >
                            Last 4 days
                          </IonRadio>
                          <br />
                          <IonRadio
                            value="Last 5 days"
                            mode="md"
                            labelPlacement="end"
                          >
                            Last 5 days
                          </IonRadio>
                          <br />
                        </IonRadioGroup>
                      </div>
                    )}
                  </div>
                  <div
                    className="ob__account_picker_wrapper"
                    style={{ flex: "0 0 25%", width: "25%", minWidth: "0" }}
                    ref={accountPickerRef}
                  >
                    <div
                      className="ob__account_picker"
                      onClick={() => {
                        setIsAccountDropDownOpen(!isAccountDropDownOpen);
                        setIsDateDropDownOpen(false);
                        setIsVisibilityDropDownOpen(false);
                        document
                          .querySelector("ion-item-sliding")
                          ?.closeOpened();
                      }}
                    >
                      <p className="ion-no-margin">
                        Account{" "}
                        {activeFilters[0]?.Accounts?.length > 0 &&
                          `(${activeFilters[0].Accounts.length})`}
                      </p>
                      <IonIcon
                        icon={expandIcon}
                        style={{
                          height: "20px",
                          width: "20px",
                          minWidth: "20px",
                          transform: isAccountDropDownOpen
                            ? "rotate(180deg)"
                            : "rotate(0)",
                        }}
                      />
                    </div>
                    {isAccountDropDownOpen && (
                      <div className="ob__account_picker_dropdown animate__animated animate__fadeIn animate__faster">
                        {accounts?.map((elem: any) => (
                          <span key={elem}>
                            <IonCheckbox
                              labelPlacement="end"
                              mode="md"
                              value={elem}
                              onIonChange={(e: any) => {
                                handleCheck(e, "Accounts");
                                CMEDfirebaseLogEvent(
                                  firebaseEventConfig.CMEDComponentNames
                                    .CMED_ORDER_BOOK,
                                  firebaseEventConfig.eventNames.CMED_ORDER_BOOK
                                    .CMED_ORDER_BOOK_APPLY_FILTER,
                                );
                              }}
                              checked={
                                activeFilters.length > 0
                                  ? activeFilters[0]["Accounts"].includes(elem)
                                  : false
                              }
                            >
                              {elem}
                            </IonCheckbox>
                            <br />
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="ob__filterchips_wrapper">
              <div>
                <IonChip
                  outline={selectedFilterPill === "All" ? false : true}
                  onClick={() => {
                    closeDropdowns();
                    setSelectedFilterPill("All");
                    setActiveFilters((prevFilters: any) => {
                      return [
                        {
                          Accounts: prevFilters[0].Accounts,
                          "Order Status": [],
                          Time: prevFilters[0].Time,
                        },
                      ];
                    });
                    document.querySelector("ion-item-sliding")?.closeOpened();
                  }}
                >
                  All
                </IonChip>
              </div>
              <div>
                <IonChip
                  outline={selectedFilterPill === "Working" ? false : true}
                  onClick={() => {
                    closeDropdowns();
                    setSelectedFilterPill("Working");
                    setActiveFilters((prevFilters: any) => {
                      return [
                        {
                          Accounts: prevFilters[0].Accounts,
                          "Order Status": ["Working", "Partially Filled"],
                          Time: prevFilters[0].Time,
                        },
                      ];
                    });
                    document.querySelector("ion-item-sliding")?.closeOpened();
                  }}
                >
                  Working
                </IonChip>
              </div>
              <div>
                <IonChip
                  outline={selectedFilterPill === "With Fills" ? false : true}
                  onClick={() => {
                    closeDropdowns();
                    setSelectedFilterPill("With Fills");
                    setActiveFilters((prevFilters: any) => {
                      return [
                        {
                          Accounts: prevFilters[0].Accounts,
                          "Order Status": [],
                          Time: prevFilters[0].Time,
                        },
                      ];
                    });
                    document.querySelector("ion-item-sliding")?.closeOpened();
                  }}
                >
                  With Fills
                </IonChip>
              </div>
              <div>
                <IonChip
                  outline={
                    activeFilters[0]["Order Status"].includes("Cancelled") &&
                    activeFilters[0]["Order Status"].includes(
                      "Partially Filled & Cancelled",
                    )
                      ? false
                      : true
                  }
                  onClick={() => {
                    closeDropdowns();
                    setSelectedFilterPill("Cancelled");
                    setActiveFilters((prevFilters: any) => {
                      return [
                        {
                          Accounts: prevFilters[0].Accounts,
                          "Order Status": [
                            "Cancelled",
                            "Partially Filled & Cancelled",
                          ],
                          Time: prevFilters[0].Time,
                        },
                      ];
                    });
                    document.querySelector("ion-item-sliding")?.closeOpened();
                  }}
                >
                  Cancelled
                </IonChip>
              </div>
              <div>
                <IonChip
                  outline={
                    activeFilters[0]["Order Status"].includes("Held") &&
                    activeFilters[0]["Order Status"].includes(
                      "Partially Filled & Held",
                    )
                      ? false
                      : true
                  }
                  onClick={() => {
                    closeDropdowns();
                    setSelectedFilterPill("Held");
                    setActiveFilters((prevFilters: any) => {
                      return [
                        {
                          Accounts: prevFilters[0].Accounts,
                          "Order Status": [
                            "Held",
                            "Partially Filled & Held",
                            "Pending & Held",
                          ],
                          Time: prevFilters[0].Time,
                        },
                      ];
                    });
                    document.querySelector("ion-item-sliding")?.closeOpened();
                  }}
                >
                  Held
                </IonChip>
              </div>
            </div>
            <RenderMobileHeader />
            <IonContent className="ion-no-padding">
              <OrderBookListComponent
                data={orderBookData}
                searchVal={searchVal}
                userCMEDEntitlements={userCMEDEntitlements}
              />
            </IonContent>
            <IonFab
              activated={fabButtonOptions}
              slot="fixed"
              vertical="bottom"
              horizontal="end"
            >
              <IonFabButton
                color={"secondary"}
                size="small"
                style={{ opacity: 0.8 }}
                onClick={() => setFabButtonOptions(!fabButtonOptions)}
              >
                <IonIcon icon={ellipsisHorizontal}></IonIcon>
              </IonFabButton>
              <IonFabList side="top">
                <IonFabButton
                  title="Hold All Orders"
                  onClick={() => {
                    closeDropdowns();
                    setIsHoldAllOrdersAlertOpen(true);
                    setFabButtonOptions(false);
                  }}
                >
                  <IonIcon icon={pauseOutline}></IonIcon>
                </IonFabButton>
                <IonFabButton
                  title={"Kill All Orders"}
                  onClick={() => {
                    closeDropdowns();
                    setIsKillAllOrdersAlertOpen(true);
                    setFabButtonOptions(false);
                  }}
                >
                  <IonIcon icon={closeCircleOutline} color="danger"></IonIcon>
                </IonFabButton>
              </IonFabList>
            </IonFab>
          </>
        )}
      </IonPage>
      <IonAlert
        className="one-alert"
        isOpen={isHoldAllOrdersAlertOpen}
        header="Hold All Orders"
        message={`Are you sure you want to hold all orders?`}
        onDidDismiss={() => setIsHoldAllOrdersAlertOpen(false)}
        buttons={[
          {
            text: "No",
            cssClass: "alert-button-cancel",
          },
          {
            text: "Yes",
            cssClass: "alert-button-confirm",
            handler: () => {
              holdAllOrdersHandler();
            },
          },
        ]}
      ></IonAlert>
      <IonAlert
        className="one-alert"
        isOpen={isKillAllOrdersAlertOpen}
        header="Kill All Orders"
        message={`Are you sure you want to kill all orders?`}
        onDidDismiss={() => setIsKillAllOrdersAlertOpen(false)}
        buttons={[
          {
            text: "No",
            cssClass: "alert-button-cancel",
          },
          {
            text: "Yes",
            cssClass: "alert-button-confirm",
            handler: () => {
              killAllOrdersHandler();
            },
          },
        ]}
      ></IonAlert>
    </>
  );
};

const OrderBook: React.FC<OrderBookProps> = (props) => (
  <OrderBookContent {...props} />
);

export default OrderBook;
